import { Reducer } from "redux";
import { WeeklyTechState } from "./@types";
import { TAction } from "loop-front";
import { OWeeklyTech } from ".";
import utilities from "Resources/Utils";
import { parseWeeklyTech } from "../WeeklyTech/weeklyTechParser";

const WeeklyTechInitialState: WeeklyTechState = {
    weeklyDialogFormProps: { open: false },
    list: []
}

const RWeeklyTech: Reducer<WeeklyTechState, TAction> = (state = WeeklyTechInitialState, action) => {
    const { LIST_RECEIVED, ACTIVITY_POST_SUCCESS, PUT_ITEM_SUCCESS, SINGLE_ITEM_RECEIVED, POST_ITEM_SUCCESS, ITEM_DELETED, SHOW_WEEKLY_TECH_DIALOG_FORM,
        HIDE_WEEKLY_TECH_DIALOG_FORM, ITEM_PATCH_SUCCESS
    } = OWeeklyTech.Actions;
    const { TOGGLE_FEATURED, TOGGLE_PUBLISH } = OWeeklyTech.Activities;
    switch (action.type) {
        case SHOW_WEEKLY_TECH_DIALOG_FORM: return { ...state, weeklyDialogFormProps: { ...action.data, open: true } };
        case HIDE_WEEKLY_TECH_DIALOG_FORM: return { ...state, weeklyDialogFormProps: { open: false, onCloseButtonClick: undefined } };
        case LIST_RECEIVED: return { ...state, list: (action.data || []).map(parseWeeklyTech) }
        case POST_ITEM_SUCCESS: return { ...state, list: utilities.updateItemList(state.list, parseWeeklyTech(action.data), 'ADD') }
        case PUT_ITEM_SUCCESS:
        case ITEM_PATCH_SUCCESS:
            return {
                ...state,
                list: utilities.updateItemList(state.list, parseWeeklyTech(action.data), 'PUT'),
                weeklyTechPostData: state.weeklyTechPostData?.id === action.data.id ? { ...state.weeklyTechPostData, ...parseWeeklyTech(action.data) } : state.weeklyTechPostData
            }
        case ITEM_DELETED:
            return {
                ...state,
                weeklyTechPostData: state.weeklyTechPostData?.id === action.data.id ? state.weeklyTechPostData : undefined,
                list: utilities.updateItemList(state.list, action.additionalDispatchData.article, 'DELETE')
            };
        case SINGLE_ITEM_RECEIVED: return { ...state, weeklyTechPostData: parseWeeklyTech(action.data) }
        case ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case TOGGLE_FEATURED:
                case TOGGLE_PUBLISH:
                    {
                        return {
                            ...state,
                            weeklyTechPostData: state.weeklyTechPostData?.id === action.data.id ? { ...state.weeklyTechPostData, ...parseWeeklyTech(action.data) } : undefined,
                            list: utilities.updateItemList(state.list, parseWeeklyTech(action.data), 'UPDATE')
                        }
                    }
            }
            return state;
        }
        default: return state;
    }
}

export default RWeeklyTech;